import React from "react";

interface IModalProps {
    onClose: (callback?: any) => void;
}

const ActivitiesManagementDetails: React.FC<IModalProps> = ({ onClose }) => {
    return (
        <>
            <h1>ActivitiesManagementDetails</h1>
            <button type="button" onClick={onClose}>
                Click
            </button>
        </>
    );
};

export default ActivitiesManagementDetails;
